import { ProviderField } from '../../../../../../models/provider';
import { Text } from '../../../../../atoms/Text/Text';
import { hasAdditionalInfo, hasAdditionalInfoAccount } from '../../../../../Templates/templates';
import { StyledCheckbox, StyledCheckmark } from './CheckboxField.styles';

export type CheckboxFieldProps = {
  field: ProviderField;
  onChange: (args: { name: string; value: string }) => void;
  value: string;
};

export const CheckboxField = ({ field, value, onChange }: CheckboxFieldProps) => {
  return (
    <StyledCheckbox>
      <input
        type="checkbox"
        id={field.name}
        defaultChecked={value === 'true'}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          onChange({
            name: field.name,
            value: e.currentTarget.checked.toString(),
          });
        }}
      />
      <StyledCheckmark>
        <path
          d="M1 4.755L5.234 9 11 1"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </StyledCheckmark>
      <label key={field.name} htmlFor={field.name}>
        {hasAdditionalInfo(field.additionalInfo) &&
        hasAdditionalInfoAccount(field.additionalInfo) &&
        field.additionalInfo.accountName ? (
          <>
            <span>{field.additionalInfo.accountName}</span>
            <Text size="small" as="div">
              {field.additionalInfo.accountNumber}
            </Text>
          </>
        ) : (
          <span>{field.description}</span>
        )}
      </label>
    </StyledCheckbox>
  );
};
